(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-search-input]');
      this.resultsElement = this.querySelector('[data-predictive-search-results]');
      this.dialog = this.closest('dialog');
      this.abortController = null;
      this.debounceTimer = null;

      this.input.addEventListener('input', () => {
        const query = this.input.value.trim();
        clearTimeout(this.debounceTimer);

        if (query.length < 2) {
          this.resultsElement.hidden = true;
          this.resultsElement.innerHTML = '';
          return;
        }

        this.debounceTimer = setTimeout(() => this.fetchResults(query), 200);
      });

      this.dialog.addEventListener('close', () => {
        this.input.value = '';
        this.resultsElement.hidden = true;
        this.resultsElement.innerHTML = '';
      });

      this.dialog.addEventListener('toggle', () => {
        if (this.dialog.open) this.input.focus();
      });
    }

    async fetchResults(query) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: this.abortController.signal }
        );
        const { resources } = await response.json();
        this.renderResults(query, resources.results);
      } catch (error) {
        if (error.name !== 'AbortError') this.resultsElement.hidden = true;
      }
    }

    renderResults(query, results) {
      const { products = [], collections = [], pages = [], articles = [] } = results;
      const hasResults = products.length || collections.length || pages.length || articles.length;

      if (!hasResults) {
        this.resultsElement.innerHTML = `<p class="predictive-search__empty">${window.themeStrings.searchNoResults.replace(
          '__QUERY__',
          query
        )}</p>`;
        this.resultsElement.hidden = false;
        return;
      }

      let html = '';

      if (products.length) {
        html += `<div class="predictive-search__group">
          <p class="predictive-search__group-title">${window.themeStrings.searchProducts}</p>
          <ul class="predictive-search__product-list">
            ${products
              .map(
                (product) => `
                  <li>
                    <a href="${product.url}" class="predictive-search__product">
                      ${
                        product.image
                          ? `<img src="${product.image}" alt="" width="56" height="56" loading="lazy">`
                          : ''
                      }
                      <span>
                        <span class="predictive-search__product-title">${product.title}</span>
                        <span class="predictive-search__product-price">${product.price}</span>
                      </span>
                    </a>
                  </li>`
              )
              .join('')}
          </ul>
        </div>`;
      }

      const linkGroup = (title, items) =>
        items.length
          ? `<div class="predictive-search__group">
              <p class="predictive-search__group-title">${title}</p>
              <ul class="predictive-search__link-list">
                ${items.map((item) => `<li><a href="${item.url}">${item.title}</a></li>`).join('')}
              </ul>
            </div>`
          : '';

      html += linkGroup(window.themeStrings.searchCollections, collections);
      html += linkGroup(window.themeStrings.searchPages, [...pages, ...articles]);

      html += `<a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(
        query
      )}" class="predictive-search__view-all">${window.themeStrings.searchViewAll.replace('__QUERY__', query)}</a>`;

      this.resultsElement.innerHTML = html;
      this.resultsElement.hidden = false;
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    class ProductBuyButtons extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      if (!this.root) return;

      this.variantInput = this.querySelector('[data-variant-id]');
      this.button = this.querySelector('[data-add-button]');
      this.buttonText = this.querySelector('[data-add-button-text]');

      this.root.addEventListener('product:variant-change', (event) => this.update(event.detail.variant));
    }

    update(variant) {
      if (variant) {
        this.variantInput.value = variant.id;
        this.variantInput.disabled = false;
      } else {
        this.variantInput.disabled = true;
      }

      this.button.disabled = !variant || !variant.available;

      if (!variant) {
        this.buttonText.textContent = this.dataset.textUnavailable;
      } else if (variant.available) {
        this.buttonText.textContent = this.dataset.textAddToCart;
      } else {
        this.buttonText.textContent = this.dataset.textSoldOut;
      }
    }
  }

  customElements.define('product-buy-buttons', ProductBuyButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-inventory"] && !Shopify.designMode) return;
  try {
    class ProductInventory extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      if (!this.root) return;

      this.textElement = this.querySelector('[data-inventory-text]');
      this.threshold = Number(this.dataset.threshold) || 0;

      this.root.addEventListener('product:variant-change', (event) => this.update(event.detail.variant));
    }

    update(variant) {
      const status = this.statusFor(variant);

      ['in-stock', 'low-stock', 'backorder', 'out-of-stock'].forEach((name) => {
        this.classList.toggle(`product-inventory--${name}`, name === status);
      });

      this.textElement.textContent = this.textFor(status, variant);
      this.hidden = !variant;
    }

    statusFor(variant) {
      if (!variant || !variant.available) return 'out-of-stock';
      if (!variant.inventory_management) return 'in-stock';
      if (variant.inventory_quantity <= 0) return 'backorder';
      if (variant.inventory_quantity <= this.threshold) return 'low-stock';
      return 'in-stock';
    }

    textFor(status, variant) {
      switch (status) {
        case 'low-stock':
          return this.dataset.textLowStock.replace('__COUNT__', variant.inventory_quantity);
        case 'backorder':
          return this.dataset.textBackorder;
        case 'out-of-stock':
          return this.dataset.textOutOfStock;
        default:
          return this.dataset.textInStock;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-gallery-stage]');
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.dialog = this.querySelector('[data-zoom-dialog]');
      this.zoomImage = this.querySelector('[data-zoom-image]');

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (event) => {
          event.preventDefault();
          this.showMedia(thumbnail.dataset.mediaId);
        });
      });

      this.observeSlides();

      if (this.dialog) {
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-zoom-trigger]');
          if (!trigger) return;
          event.preventDefault();
          this.zoomImage.src = trigger.dataset.zoomSrc;
          this.zoomImage.alt = trigger.dataset.zoomAlt || '';
          this.dialog.showModal();
        });
      }

      this.closest('[data-product-root]')?.addEventListener('product:variant-change', (event) => {
        const mediaId = event.detail.variant?.media_id;
        if (mediaId) this.showMedia(String(mediaId));
      });
    }

    observeSlides() {
      if (!this.stage || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActiveThumbnail(entry.target.dataset.mediaId);
          });
        },
        { root: this.stage, threshold: 0.6 }
      );

      this.querySelectorAll('[data-gallery-slide]').forEach((slide) => observer.observe(slide));
    }

    showMedia(mediaId) {
      const slide = this.querySelector(`[data-gallery-slide][data-media-id="${mediaId}"]`);
      if (!slide) return;
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      this.setActiveThumbnail(mediaId);
    }

    setActiveThumbnail(mediaId) {
      this.thumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.mediaId === mediaId;
        thumbnail.classList.toggle('gallery__thumbnail--active', isActive);
        if (isActive) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-meta"] && !Shopify.designMode) return;
  try {
    class ProductMeta extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      if (!this.root) return;

      this.skuRow = this.querySelector('[data-sku-row]');
      this.skuValue = this.querySelector('[data-sku]');
      if (!this.skuRow) return;

      this.root.addEventListener('product:variant-change', (event) => {
        const sku = event.detail.variant?.sku;
        this.skuValue.textContent = sku || '';
        this.skuRow.hidden = !sku;
      });
    }
  }

  customElements.define('product-meta', ProductMeta);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    class ProductPrice extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      if (!this.root) return;

      this.currentElement = this.querySelector('[data-price-current]');
      this.compareElement = this.querySelector('[data-price-compare]');
      this.compareAmountElement = this.querySelector('[data-price-compare-amount]');

      this.root.addEventListener('product:variant-change', (event) => this.update(event.detail.variant));
    }

    update(variant) {
      if (!variant) return;

      this.currentElement.innerHTML = variant.price;

      const onSale = Boolean(variant.compare_at_price);
      this.classList.toggle('product-price--on-sale', onSale);
      this.compareElement.hidden = !onSale;
      this.compareAmountElement.innerHTML = onSale ? variant.compare_at_price : '';
    }
  }

  customElements.define('product-price', ProductPrice);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity"] && !Shopify.designMode) return;
  try {
    class ProductQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      if (!this.input) return;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button) return;
        this.step(Number(button.dataset.quantityStep));
      });

      this.closest('[data-product-root]')?.addEventListener('product:variant-change', (event) => {
        this.updateMax(event.detail.variant);
      });
    }

    step(amount) {
      const min = Number(this.input.min) || 1;
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const next = Math.min(max, Math.max(min, Number(this.input.value) + amount));

      if (next === Number(this.input.value)) return;
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateMax(variant) {
      const tracked = variant && variant.inventory_management && variant.inventory_policy === 'deny';

      if (tracked && variant.inventory_quantity > 0) {
        this.input.max = variant.inventory_quantity;
        if (Number(this.input.value) > variant.inventory_quantity) this.input.value = variant.inventory_quantity;
      } else {
        this.input.removeAttribute('max');
      }
    }
  }

  customElements.define('product-quantity', ProductQuantity);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    class ProductStickyBar extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      if (!this.root) return;

      this.button = this.querySelector('[data-sticky-add-button]');
      this.buttonText = this.querySelector('[data-sticky-add-text]');

      this.root.addEventListener('product:variant-change', (event) => this.update(event.detail.variant));
      this.observeMainButton();
    }

    observeMainButton() {
      const mainButton = this.root.querySelector('[data-add-button]');
      if (!mainButton || !('IntersectionObserver' in window)) return;

      this.hidden = false;

      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('sticky-bar--visible', scrolledPast);
        },
        { threshold: 0 }
      );

      observer.observe(mainButton);
    }

    update(variant) {
      this.button.disabled = !variant || !variant.available;

      if (!variant) {
        this.buttonText.textContent = this.dataset.textUnavailable;
      } else if (variant.available) {
        this.buttonText.textContent = this.dataset.textAddToCart;
      } else {
        this.buttonText.textContent = this.dataset.textSoldOut;
      }
    }
  }

  customElements.define('product-sticky-bar', ProductStickyBar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-product-root]');
      this.inputs = Array.from(this.querySelectorAll('.variant-picker__input'));
      this.selects = Array.from(this.querySelectorAll('.variant-picker__select'));

      const data = this.querySelector('[data-variant-data]');
      if (!data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch (error) {
        this.variants = [];
      }

      this.addEventListener('change', (event) => {
        if (event.target.matches('.variant-picker__input, .variant-picker__select')) this.onOptionChange();
      });

      this.updateAvailability();
    }

    get selectedOptions() {
      const options = [];
      this.inputs.forEach((input) => {
        if (input.checked) options[Number(input.dataset.optionIndex)] = input.value;
      });
      this.selects.forEach((select) => {
        options[Number(select.dataset.optionIndex)] = select.value;
      });
      return options;
    }

    findVariant(options) {
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    onOptionChange() {
      const options = this.selectedOptions;
      const variant = this.findVariant(options);

      options.forEach((value, index) => {
        const label = this.querySelector(`[data-option-selected="${index}"]`);
        if (label) label.textContent = value;
      });

      this.updateAvailability();
      this.updateUrl(variant);

      this.root?.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant } }));
    }

    updateAvailability() {
      const selected = this.selectedOptions;

      const availabilityFor = (index, value) => {
        const candidate = selected.slice();
        candidate[index] = value;
        return this.findVariant(candidate);
      };

      this.inputs.forEach((input) => {
        const match = availabilityFor(Number(input.dataset.optionIndex), input.value);
        const label = input.nextElementSibling;
        if (label) label.classList.toggle('variant-picker__value--unavailable', !match || !match.available);
      });

      this.selects.forEach((select) => {
        const index = Number(select.dataset.optionIndex);
        Array.from(select.options).forEach((option) => {
          // Only combinations that don't exist at all are disabled; a value that
          // exists but is sold out stays selectable so its state can be shown.
          option.disabled = !availabilityFor(index, option.value);
        });
      });
    }

    updateUrl(variant) {
      if (!variant || !window.history.replaceState) return;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
